export const colors = {
  // Brand colors
  primaryPurple: '#5D3FD3',
  secondaryPurple: '#7B68EE',
  lightPurple: '#9370DB',
  
  // Neutral colors
  black: '#000000',
  darkGray: '#333333',
  gray: '#666666',
  lightGray: '#999999',
  white: '#FFFFFF',
  
  // Functional colors
  success: '#4CAF50',
  warning: '#FF9800',
  error: '#F44336',
  info: '#2196F3',
} 